<template lang="pug">
  article.news-item
    router-link(:to="{name: 'pressdetail',params: {id: news.id}}")
      div.banner(v-if="news.picture")
        img(:src="news.picture")
    div.content
      router-link(:to="{name: 'pressdetail',params: {id: news.id}}", tag="h3") {{news.title}}
      p.summary
        small {{news.summary}}
      router-link.more(:to="{name: 'pressdetail',params: {id: news.id}}", tag="a")
        small 阅读全文
</template>

<script>
export default {
  name: 'NewsItem',
  props: ['news', 'relayout'],
  mounted () {
    this.$nextTick(() => {
      this.relayout()
    })
    let img = new Image()
    img.src = this.news.img
    img.onload = () => {
      this.imageLoaded()
    }
  },
  methods: {
    imageLoaded () {
      this.relayout()
    }
  }
}
</script>

<style lang="scss" scoped>
  .news-item {
    margin-bottom: 5px;
    overflow: hidden;
    .banner img {
      max-width: 100%;
    }
    h3 {
      font-size: 2.29rem;
      text-transform: uppercase;
      margin: 0;
      margin-bottom: 0;
      font-family: akzidenz-grotesk-condensed;
      font-weight: 400;
      line-height: 1.1;
      color: #1a1a1a;
    }
  }

  .content {
    background: #fff;
    padding: 2rem;
    color: initial;
  }

  .summary {
    color: #7b7b82;
  }

  .more {
    color: #0484a9;
  }
</style>
